import { UserSignaturesType, IUserSignatureInfo } from './SignaturesPart';
import { ITask } from 'store/tasks/tasksType';

type SignatureStatus = IUserSignatureInfo['signature']['status'];

const getDefaultSignatureTitle: { [key in UserSignaturesType]: string } = {
  guest: 'افراد مهمان در جلسه',
  absent: 'افراد غایب در جلسه',
  present: 'افراد حاضر در جلسه',
  vice: 'افراد با حضور جانشین',
};

const getWithOutSignatureTitle: { [key in SignatureStatus]: string } = {
  signed: 'امضا کرده است',
  notSigned: 'امضا نکرده است',
};

export default {
  noRoleForUser: 'بدون سمت',
  guest: 'مهمان',

  withoutSignature(status: SignatureStatus) {
    return getWithOutSignatureTitle[status];
  },
  getSignatureBoxTitle(
    whichType: UserSignaturesType,
    customTitle?: string,
    template?: ITask
  ) {
    if (whichType === 'present' && template?.assigneeCompleteTitle) {
      return `افراد ${template?.assigneeCompleteTitle} در جلسه`;
    }
    if (whichType === 'absent' && template?.assigneeNotStartedTitle) {
      return `افراد ${template?.assigneeNotStartedTitle} در جلسه`;
    }
    if (whichType === 'vice' && template?.assigneeStartedTitle) {
      return `افراد ${template?.assigneeStartedTitle} در جلسه`;
    }
    return customTitle ? customTitle : getDefaultSignatureTitle[whichType];
  },
};
